import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, REPORT } from "../config/apiEndPoint";
import { POST, POST_V2 } from "config/api.config";
import { resolveAsyncTeamFilterPageName } from "helpers/metadataFilterHelpers";

export const submitSessionReportFilterData = async (data = array()) => {
  try {
    const response = await POST(REPORT.SESSION_ACTIVITY, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST V2 `common/team` — Session Report team filter (`ReportFiltered`). */
export const fetchSessionReportTeamOptions = async (pageName = "ReportFiltered") => {
  try {
    const resolvedPageName = resolveAsyncTeamFilterPageName(pageName) || pageName;
    if (!resolvedPageName) return null;
    const response = await POST_V2(COMMON.TEAM, { pageName: resolvedPageName });
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
